type DocumentType = 'zip' | 'pdf';

export const downloadDocuments = async (
  response: any,
  downloadedFileName: string,
  documentType: DocumentType
) => {
  let data = response;
  if (
    documentType === 'pdf' &&
    response &&
    typeof response.blob === 'function'
  ) {
    data = await response.blob();
  }

  const blobUrl = window.URL.createObjectURL(data);
  const link = document.createElement('a');
  link.href = blobUrl;
  link.setAttribute('download', `${downloadedFileName}.${documentType}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(blobUrl);
};
